export default class InvalidPhoneNumberError extends Error {}
